import { render, staticRenderFns } from "./cases-create.vue?vue&type=template&id=e649e51c&scoped=true"
import script from "./cases-create.vue?vue&type=script&lang=js"
export * from "./cases-create.vue?vue&type=script&lang=js"
import style0 from "./cases-create.vue?vue&type=style&index=0&id=e649e51c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_rj3s3qgubxnefw7btmb34khrpq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e649e51c",
  null
  
)

export default component.exports